<template>
    <v-container>
        <v-container  v-for="(team, tid) in data" :key="tid">
            <template v-if="team !== undefined">
                <team-users :team="team" :team_stat="data_stat[team.id]" :team_user_action="team_user_action"></team-users>
            </template>
        </v-container>
    </v-container>



  </template>
<script>

import TeamUsers from './TeamUsers.vue';


export default {

    name: "teams-users",

    props: {
        teams: { type: Array, defaut:[] },
        teams_stat: { type: Object, default:{} },
        team_user_action: { default: '' }

    },
    data() {

        let data = this.teams;
        let data_stat = this.teams_stat;




        return {
            data,
            data_stat
        }
    },

    mounted() {
    },
    methods: {

    },

    components: {
        TeamUsers,
    }
}

</script>
